import { RudderAnalytics } from '@rudderstack/analytics-js';

export const analytics = new RudderAnalytics();
